import React, {useState} from 'react';
import BasicInfo from './basic-info/basic-info.jsx';
import AdditionalInfo from './additional-info/additional-info.jsx';
import CustomerContext from './customer-context.js';
import {customerPropTypes} from '../prop-types.js';

const Customer = ({customer}) => {
  const [error, setError] = useState();
  const [isOpen, setIsOpen] = useState(false);

  return (
    <CustomerContext.Provider value={{customer}}>
      <BasicInfo error={error} isOpen={isOpen} setIsOpen={setIsOpen} />

      <AdditionalInfo isOpen={isOpen} setError={setError} />
    </CustomerContext.Provider>
  );
};

Customer.propTypes = {
  customer: customerPropTypes.isRequired
};

export default Customer;
